import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const WxLaunchHack = Loadable({
    loader: () => import(/* webpackChunkName: "WxLaunchHack" */ './wxLaunchHack'),
    loading: () => <div />,
});
